import {gql, useQuery} from "@apollo/client";
import {getBookingConfig} from "../graphql/queries";
import {useEffect, useMemo} from "react";
import {onCreateBookingConfig, onUpdateBookingConfig} from "../graphql/subscriptions";
import {Building} from "../API";
import {BookingConfigDays} from "../types/BookingConfigDaysTypes";

const defaultBookingConfig: BookingConfigDays = {
    __typename: "BookingConfigDays",
    maxDaysInAdvance: 300,
    maxBookableDays: 300
}

export function useBookingLimitation(building: Building | undefined): BookingConfigDays {
    return useMemo(() => {
        if (building?.maxBookableDays) {
            return {
                __typename: "BookingConfigDays",
                maxBookableDays: building.maxBookableDays,
                maxDaysInAdvance: building.maxDaysInAdvance ?? defaultBookingConfig.maxDaysInAdvance
            }
        } else {
            return defaultBookingConfig;
        }
    }, [building])
}
